module.exports = __webpack_public_path__ + "static/img/101851.c6f92a1b.png";